import React from 'react';
import { cn } from '../../lib/utils';

export interface PropertyItemProps {
  label: string;
  value: React.ReactNode;
  className?: string;
  mono?: boolean;
}

export function PropertyItem({ label, value, className, mono = true }: PropertyItemProps) {
  return (
    <div className={cn('flex flex-col gap-1', className)}>
      <span className="text-[10px] font-bold uppercase tracking-widest text-muted-foreground/60">
        {label}
      </span>
      <div
        className={cn(
          'text-xs text-foreground truncate',
          mono && 'font-mono'
        )}
      >
        {value}
      </div>
    </div>
  );
}

export interface PropertyGridProps {
  children: React.ReactNode;
  className?: string;
  cols?: 1 | 2 | 3 | 4;
}

export function PropertyGrid({ children, className, cols = 2 }: PropertyGridProps) {
  const colClass = {
    1: 'grid-cols-1',
    2: 'grid-cols-1 sm:grid-cols-2',
    3: 'grid-cols-1 sm:grid-cols-3',
    4: 'grid-cols-2 sm:grid-cols-4',
  }[cols];

  return (
    <div className={cn('grid gap-x-6 gap-y-4', colClass, className)}>
      {children}
    </div>
  );
}
